import {APP_NAME} from '../brand';

// Because there are all brand names, it is unnecessary for them to be translatable.
export default [
    {tag: 'scratch', intlLabel: 'Scratch'},
    {tag: 'tw', intlLabel: 'TurboWarp'},
    {tag: 'berry', intlLabel: APP_NAME}
];
